/* eslint-disable spire/export-styles */
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography from "@insite/mobius/Typography";
// eslint-disable-next-line spire/fenced-imports
import { bannerStyles } from "@tKgpco/Overrides/Widgets/Category/CategoryName";

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { WidgetDefinition } from "@insite/client-framework/Types/ContentItemDefinitions";
import * as React from "react";
import { connect } from "react-redux";

const enum fields {
    overrideTitle = "overrideTitle",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.overrideTitle]: string;
    };
}

const mapStateToProps = (state: ApplicationState) => ({
    pageTitle: getCurrentPage(state).fields.title,
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

const PageTitle: React.FunctionComponent<Props> = ({ pageTitle, fields }: Props) => (
    <StyledWrapper {...bannerStyles.bannerStyle}>
        <Typography variant="h2" as="h1" data-test-selector="PageTitle">
            {fields.overrideTitle || pageTitle}
        </Typography>
    </StyledWrapper>
);

const definition: WidgetDefinition = {
    group: "Basic",
    icon: "PageTitle",
    fieldDefinitions: [
        {
            name: fields.overrideTitle,
            displayName: "Text",
            editorTemplate: "TextField",
            defaultValue: "",
            fieldType: "General",
            tooltip: "Replace the title",
            placeholder: "title...",
        },
    ],
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(PageTitle),
    definition,
};

export default widgetModule;
